const rootConfig = {
    text: 'https://www.customily.com/',
    pixelSize: 20,
    lightColor: '#000000',
    darkColor: 'none'
};

const updatedConfig = (newConfig) => {
    if (!newConfig) return rootConfig;

    let config = {
        ...rootConfig,
        ...newConfig
    };

    return config;
};

(function () {
    'ngInject';

    angular.module('app.shared.services').service('QrUtilService', qrUtilService);

    function qrUtilService(QrAPIService) {
        async function getQrSvg(config, mutex = null) {
            let svg = '';
            if (mutex != null) {
                await mutex.acquire();
                try {
                    const response = await QrAPIService.fetchSvgString(updatedConfig(config));
                    svg = response.svg;
                } finally {
                    mutex.release();
                }
            } else {
                const response = await QrAPIService.fetchSvgString(updatedConfig(config));
                svg = response.svg;
            }
            return svg;
        }

        return {
            getQrSvg
        };
    }
})();
